import { api } from './api';

const makeRoleHeaders = (userRoleUuid) => {
    if (!userRoleUuid) {
        throw new Error('Missing active user role UUID.');
    }

    return {
        'USER-ROLE': userRoleUuid
    };
};

export const listPatientRecords = async ({
    userRoleUuid,
    subjectRoleUuid,
    dataPostType,
    timestampStart,
    timestampEnd,
    order,
    paginationLimit,
    paginationToken
} = {}) =>
    api.get('/records', {
        headers: {
            ...makeRoleHeaders(userRoleUuid),
            ...(subjectRoleUuid ? { 'CVP-QUERY-SUBJECT': subjectRoleUuid } : {}),
            ...(dataPostType ? { 'CVP-QUERY-DATA-POST-TYPE': dataPostType } : {}),
            ...(timestampStart ? { 'CVP-QUERY-TIMESTAMP-START': timestampStart } : {}),
            ...(timestampEnd ? { 'CVP-QUERY-TIMESTAMP-END': timestampEnd } : {}),
            ...(order ? { 'CVP-QUERY-ORDER': order } : {}),
            ...(paginationLimit ? { 'PAGINATION-LIMIT': paginationLimit } : {}),
            ...(paginationToken ? { 'PAGINATION-TOKEN': paginationToken } : {})
        }
    });
